module.exports = __webpack_public_path__ + "static/img/6.54983e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/6.png
// module id = QFQK
// module chunks = 0